exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subscribeInfo[data-v-2cf32425]{height:46px;width:150px}.content-detail[data-v-2cf32425]{background:#fff}.content-detail .detail-header[data-v-2cf32425]{margin-bottom:20px}.content-detail .service-label-group[data-v-2cf32425]{font-size:12px;color:#999;margin-bottom:10px}.content-detail .service-label-group span[data-v-2cf32425]{margin-right:10px}.content-detail .service-label-group span .ico[data-v-2cf32425]{-webkit-transform:scale(.8);transform:scale(.8);display:inline-block;margin-right:5px}", ""]);

// exports
